import React from 'react';
import '../components/styles/pricing.css';

const PricingTables = () => {
  const pricingData = {
    inStudioBridal: [
      { service: "Bridal Makeup on Wedding Day", price: 300 },
      { service: "Bridal Party Makeup", price: 120 },
      { service: "Jr. Bridesmaid Makeup", price: 85 },
      
    ],
    mobileBridal: [
      { service: "Graduation Makeup", price: 120 },
      { service: "Corporate Event Makeup", price: 120 },
      { service: "Prom Makeup", price: 140 },
      { service: "Glam Makeup", price: 140 },
      { service: "Soft Glam Makeup", price: 120 },
    ],
    glamServices: [
      { service: "Lash Strips/Clusters", price: 25 },
      { service: "Application of Pre-Owned Lashes", price: 15 },
      { service: "Bridal Trial", price: 140 },
    ],
    eventServices: [
      { service: "Group Makeup (4+ People)", price: 100 },
      { service: "Group Makeup (Bridal Party/Per person. Bridal Makeup is at full price)", price: 100 },
    ],
    additionalServices: [
      { service: "Half Day (4 hrs. Touch Ups)", price: 400 },
      { service: "Full Day Booking (8 hrs Touch ups)", price: 700 },
    ],
    continuousServices: [
      { service: "Bridal Makeup on Wedding Day", price: 350 },
      { service: "Bridal Party Makeup", price: 140 },
      { service: "Jr. Bridesmaid Makeup", price: 100 },
      { service: "Graduation Makeup", price: 150 },
      { service: "Corporate Event Makeup", price: 150 },
      { service: "Prom Makeup", price: 160 },
      { service: "Glam Makeup", price: 160 },
      { service: "Soft Glam Makeup", price: 150 },
    ],
  };

  const renderTable = (data, title) => (
    <div className="table-section">
      <div className="table-wrapper">
        <table className="pricing-table">
          <thead>
            <tr>
              <th className="service-column">{title}</th>
              <th>LORREN'S RATES</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td className="service-name">{item.service}</td>
                <td className="price-cell">
                  {item.price ? `$${item.price}` : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div className="pricing-container">
      <h1 className="main-title">
        <span className="star">✦</span>
        Makeup Services & Rates
        <span className="star">✦</span>
      </h1>
      
      {renderTable(pricingData.inStudioBridal, "BRIDAL MAKEUP SERVICES")}
      {renderTable(pricingData.mobileBridal, "SPECIAL OCCASION MAKEUP SERVICES")}
      {renderTable(pricingData.glamServices, "ADDITIONAL SERVICES")}
      {renderTable(pricingData.eventServices, "GROUP MAKEUP SERVICES (MINIMUM 3 PEOPLE)")}
      {renderTable(pricingData.additionalServices, "CONTINUOUS SERVICES")}
      {renderTable(pricingData.continuousServices, "MOBILE SERVICES")}
    </div>
  );
};

export default PricingTables;